// related product slider
$('.multiple-items').owlCarousel({
  loop:true,
  margin:10,
  nav:true,
  dots: true,
  responsive:{
    0:{
      items:1
    },
    600:{
      items:1
    },
    1000:{
      items:1
    }
  }
});


// Product page slider js

$('.shop-slider-nav').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  //asNavFor: '.shop-slider',
  dots: false,
  arrows: true,
  centerMode: false,
  vertical: false,
  verticalSwiping: false,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        vertical: false,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        vertical: false,
      }
    }

  ]
});



// collection page sidebar for mobile-accordion
$('.sidebar-content h3').click(function(){  
  var w = window.innerWidth;
  if(w<=900){

    if ($(this).hasClass('active')){

      $('.sidebar-content h3').removeClass('active');
      $('.sidebar-content .inner-content').slideUp();

    }else{

      $('.sidebar-content h3').removeClass('active');
      $('.sidebar-content .inner-content').slideUp();

      $(this).addClass('active');
      $(this).siblings('.sidebar-content .inner-content').slideDown();

    }
  }
});


    // FAQ Accordian Tab

jQuery(document).ready(function($){

  $(".cms-static-page-view .accordion-section-title").click(function(){
    $(this).next(".cms-static-page-view .accordion-section-content").slideToggle("slow")
    .siblings(".cms-static-page-view .accordion-section-content:visible").slideUp("slow");
    $(this).toggleClass("active");
    $(this).siblings(".cms-static-page-view .accordion-section-title").removeClass("active");
  });
});

// Mobile Menu 

if ($(window).width() < 900) {

  $('.sidenav a svg').on("click", function (e) {
    $(this).parent('.site-nav__link--button').next('.site-nav__dropdown').slideToggle(600);
    $(this).toggleClass('ion-ios-arrow-down ion-ios-arrow-up');
    e.stopPropagation();
    e.preventDefault();
  });
}


// stickey header

$(window).scroll(function(){
  var w = window.innerWidth;
  var scroll = $(window).scrollTop();

  if(w>901){
    if (scroll >= 123){ 
      $('.main-header').addClass('sticky');
    }else{
      $('.main-header').removeClass('sticky');
    }
  }
});


/* ------ List-Grid view on collection page  ------  */

function replaceUrlParam(url, paramName, paramValue) {
    var pattern = new RegExp('('+paramName+'=).*?(&|$)'),
        newUrl = url.replace(pattern,'$1' + paramValue + '$2');
    if ( newUrl == url ) {
      newUrl = newUrl + (newUrl.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
    }
    return newUrl;
  }

$(function ($) { 
  
    $('.change-view').on('click', function() {
      
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  
  
});

/* ------ List-Grid view on collection page  end ------  */

// Show by per page script
jQuery('.sort-per-page select.num').on('change', function(){
  window.location.replace(jQuery(this).val());
});

// Show by per page script end

// Home main slider

$('#home-main-slider').owlCarousel({
  loop:true,
  margin:10,
  nav:true,
  dots: true,
  autoplay: true,
  autoplayTimeout: 5000,
  responsive:{
    0:{
      items:1
    },
    600:{
      items:1
    },
    1000:{
      items:1
    }
  }
})



// Top Seller Products Slider 

$('#top-seller').owlCarousel({
  loop:true,
  dots: false,
  margin:10,
  nav: true,
  navText: ["<img src=//www.clayinmotion.com/cdn/shop/t/37/assets/left-arrow.png?v=103611027162687834051628586346 >", "<img src=//www.clayinmotion.com/cdn/shop/t/37/assets/right-arrow.png?v=31465288040989087321628586360 >"],
            responsiveClass:true,
            autoplay: false,
            responsive:{
            0:{
            items:1,
            nav:true
            },
            600:{
            items:2,
            nav:true
            },
            800:{
            items:2,
            margin:0,
            nav:true
            },
            1000:{
            items:4,
            nav:true,
            loop:true
            }
            }
            });


            


            // video popup - magnificPopup

            $(function() {
            $('.popup-video').magnificPopup({
            disableOn: 700,
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false
            });
            });


            // Gallery image popup- Home

            $('.image-popup-vertical-fit').magnificPopup({
            type: 'image',
            mainClass: 'mfp-with-zoom', 
            gallery:{
            enabled:true
            },

            zoom: {
            enabled: true, 

            duration: 300, // duration of the effect, in milliseconds
            easing: 'ease-in-out', // CSS transition easing function

            opener: function(openerElement) {

            return openerElement.is('img') ? openerElement : openerElement.find('img');
            }
            }

            });


            // Footer Accordian Tab

            $('.fot-top-title h5').click(function(){
            var w = window.innerWidth;
            if(w<=767){

            if ($(this).hasClass('active')){

            $('.fot-top-title h5').removeClass('active');
            $('.fot-top-title ul').slideUp();

            }else{

            $('.fot-top-title h5').removeClass('active');
            $('.fot-top-title ul').slideUp();

            $(this).addClass('active');
            $(this).siblings('.fot-top-title ul').slideDown();

            }
            }
            });

  // Shop By Category Accordian
            
		function openCity(evt, cityName) {
            var i, tabcontent, tablinks;
            tabcontent = document.getElementsByClassName("tabcontent");
            for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].style.display = "none";
			}
		tablinks = document.getElementsByClassName("tablinks");
      	for (i = 0; i < tablinks.length; i++) {
        	tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      document.getElementById(cityName).style.display = "block";
      evt.currentTarget.className += " active";
    }

    // Get the element with id="defaultOpen" and click on it
   document.getElementById("perm-tab").click();

//search bar js start

function showhide()
{
  var div = document.getElementById("toggle-search");
  if (div.style.display !== "none") {
    $('#icon').addClass("searchopen");
    $('#icon').removeClass("searchclose");
    div.style.display = "none";
  }
  else {
    div.style.display = "block";
    $('#icon').removeClass("searchopen");
    $('#icon').addClass("searchclose");
  }
}

// /*---------------- Featured Slider ------------------*/
// $('.swatch-slider').slick({
//   centerMode: false,
//   slidesToShow: 4,
//   autoplay: true,
//   arrows: true
// });


